import React, { FC, useCallback, useMemo } from 'react';
import { PagiItemBox, PaginationCont } from './Pagination.styles';
import { usePagination } from '../../hooks/usePagination';
import ArrowButton from '../ArrowButton/ArrowButton';

interface IPagination {
  activePage: number;
  totalPageCount: number;
  applyFilters: (page: number) => void;
}

const PaginationComponent: FC<IPagination> = ({ activePage, totalPageCount, applyFilters }) => {
  const { createPaginationArr, countPageToJumpForward, countPageToJumpPrevious } = usePagination(
    activePage,
    totalPageCount
  );

  const renderPaginationBoxes = useCallback(() => {
    return createPaginationArr?.map((val) => {
      const { id, value } = val;
      const jumpNext = 'jumpNext' in val ? val.jumpNext : undefined;
      const isActive = value === activePage;
      const isJumpButton = value === '...';
      const jumpValue = jumpNext ? countPageToJumpForward() : countPageToJumpPrevious();
      if (isJumpButton) {
        return (
          <PagiItemBox key={id} onClick={() => applyFilters(jumpValue)}>
            {value}
          </PagiItemBox>
        );
      }
      return (
        <PagiItemBox active={isActive} key={id} onClick={() => applyFilters(Number(value))}>
          {String(value)}
        </PagiItemBox>
      );
    });
  }, [
    activePage,
    applyFilters,
    countPageToJumpForward,
    countPageToJumpPrevious,
    createPaginationArr,
  ]);

  const renderCustomPagination = useMemo(() => {
    const noMorePrev = activePage === 1;
    const noMoreNext = activePage === totalPageCount;
    return (
      <>
        <ArrowButton
          disabled={noMorePrev}
          onClick={() => !noMorePrev && applyFilters(activePage - 1)}
          left
        />
        {renderPaginationBoxes()}
        <ArrowButton
          onClick={() => !noMoreNext && applyFilters(activePage + 1)}
          disabled={noMoreNext}
        />
      </>
    );
  }, [activePage, totalPageCount, renderPaginationBoxes, applyFilters]);

  return <PaginationCont>{renderCustomPagination}</PaginationCont>;
};

export default PaginationComponent;
